import { REQUEST_CREATE_ACTIVITY, RECEIVE_CREATE_ACTIVITY, UPDATE_CREATE_ACTIVITY_VALUES, CLEAR_CREATE_ACTIVITY_VALUES } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { hideCreateActivityModal } from './modal';
import { getBackendUrl } from '../env';


export const requestCreateActivity = () => ({
    type: REQUEST_CREATE_ACTIVITY
})

export const receiveCreateActivity = (result) => ({
    type: RECEIVE_CREATE_ACTIVITY,
    result: result
})

export const updateCreateActivityFormValues = values => ({
    type: UPDATE_CREATE_ACTIVITY_VALUES,
    values: values
})

export const clearCreateActivityModalValues = () => ({
    type: CLEAR_CREATE_ACTIVITY_VALUES
})

export const canCreateActivity = (state) => {
    if(state == null){
        return false;
    }

    return true;
}

export const createActivity = (state) => dispatch => {
    if(!canCreateActivity(state)){
        return false;
    }

    dispatch(requestCreateActivity()); // Flag to the application that we have started our request.

    //
    // Create our request's body
    //

    const payload = {
        activityName: state.activityName,
        sequenceName: state.sequenceName,
        sceneName: state.sceneName,
        instructionalName: state.instructionalName,
        description: state.description,
        product: state.product,
        scores: state.scores
    };

    //
    // Send our request off.
    //

    (fetch(`${getBackendUrl()}/api/v1/data/activity`, {method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json'}})
        .then(getBody)
        .then(json => {
            dispatch(receiveCreateActivity(json));
            dispatch(clearCreateActivityModalValues());
            dispatch(hideCreateActivityModal());
        }))
        .catch(err => {
            dispatch(receiveCreateActivity(null));
            dispatch(displayError(err));
        });
}


// WEBPACK FOOTER //
// ./src/actions/createActivity.js